var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.01229 18H0.271509V5.97318H4.01229V18ZM2.12179 4.36425C0.955308 4.36425 -0.0100555 3.35866 -0.0100555 2.15196C-0.0100555 1.38771 0.392179 0.663687 1.03575 0.301676C1.71955 -0.100559 2.56425 -0.100559 3.20782 0.301676C3.89162 0.663687 4.29385 1.38771 4.29385 2.15196C4.29385 3.35866 3.32849 4.36425 2.12179 4.36425ZM14.2693 18V12.1676C14.2693 10.7598 14.2291 8.98994 12.2983 8.98994C10.3676 8.98994 10.086 10.4782 10.086 12.0469V18H6.34525V5.97318H9.92514V7.62235H9.96536C10.4883 6.69721 11.695 5.69162 13.505 5.69162C17.286 5.69162 18.0101 8.18547 18.0101 11.4034V18H14.2693Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2fdf6139e8f18a50aaf6bbf7597b2885.svg";
export { ForwardRef as ReactComponent };